import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';
import macOsScrollBar from 'main/theme/mac-os-scrollbar';

export default makeStyles({ name: 'Collapsible' })((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 16
    },
    collapse: {
        width: '100%',
        ...macOsScrollBar(),
        overflowX: 'auto',
        overflowY: 'hidden',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            scrollbarWidth: 'none',
            ['&::-webkit-scrollbar']: {
                display: 'none'
            }
        }
    },
    button: {
        margin: 'auto',
        padding: '12px 24px',
        borderRadius: 12,
        background: '#FFF !important',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    _hidden: {
        display: 'none'
    },
    _inverted: {
        background: '#151515 !important',
        color: '#D3D3D3'
    }
}));
